export const formatTimeToIST = (timestamp) => {
 
  const timestampInMs = timestamp.toString().length === 10 ? timestamp * 1000 : timestamp;

  try {
    return new Date(timestampInMs).toLocaleTimeString('en-IN', {
      timeZone: 'Asia/Kolkata',  // Convert to IST
      hour12: false,  // 24-hour format
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  } catch (err) {
    console.error('Error formatting time to IST:', err);
    return timestamp?.toString() || '';  // Return original value if parsing fails
  }
}; 